import React, { cloneElement, ReactElement, useRef } from 'react'
import fileStyles from '~/styles/molecules/form/upload.module.scss'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { FormPartsProps, useInputFileHandleChange } from '~/common/form/formCommon'
import { filterFileMaxSize } from '~/common/define/file'
import FileInput from '~/components/atoms/upload/FileInput'
import FormWidgetErrorMessages from '~/components/molecules/form/FormWidgetErrorMessages'
import FormWidgetList from '~/components/wrapper/form/FormWidgetList'

interface FileUploadProps extends FormPartsProps<File|string|any> {
  fileName: string
  children: ReactElement
}

const FormFileUpload = ({children, name, fileName, value, onChange, label = '', errors = []}: FileUploadProps) => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const inputRef = useRef(null)
  const clickableChildren = cloneElement(children, {onClick: () => inputRef.current.click()})

  const inputFileHandle = useInputFileHandleChange(name, fileName, onChange)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files)
    const filteredFiles = filterFileMaxSize(files, dispatch, t)
    if (filteredFiles.length > 0 && files.length == filteredFiles.length) {
      inputFileHandle(e)
    }
  }

  return (
    <div className={fileStyles.list}>
      <FileInput onChange={handleChange} inputRef={inputRef}/>
      {clickableChildren}
      {value && <p className={fileStyles.name}>{value.name}</p>}
      <FormWidgetErrorMessages label={label} errors={errors} />
    </div>
  )
}

export default FormFileUpload